import React, { useState, useEffect } from 'react';
import { object } from 'prop-types';
import { useEntidad } from '../../hooks/useEntidad';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { TableCustom } from '../../common';
import { getFormatNumber } from '../../../utils/convert';


const CertificadosApremioItemGrid = (props) => {

    //hooks
    const [state, setState] = useState({
        idCertificadoApremio: 0,
        list: []
    });

    const mount = () => {
        setState(prevState => {
            const list = props.data.list;
            return {...prevState,
                idCertificadoApremio: props.data.idCertificadoApremio,
                list: list };
        });
    }
    useEffect(mount, [props.data]);

    const [, getRowEntidad] = useEntidad({
        entidades: ['SubTasa'],
        onLoaded: (entidades, isSuccess, error) => {
          if (isSuccess) {
            setState(prevState => ({...prevState}));
          }
          else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'SubTasa',
          timeout: 0
        }
    });

    const getDescSubTasa = (id) => {
        const row = getRowEntidad('SubTasa', id);
        return (row) ? row.codigo + " - " + row.descripcion : '';
    }

    const tableColumns = [
        { Header: 'Período', accessor: 'periodo', width: '10%', alignCell: 'right' },
        { Header: 'Cuota', accessor: 'cuota', width: '10%', alignCell: 'right' },
        { Header: 'Sub tasa', Cell: (props) => getDescSubTasa(props.value), accessor: 'idSubTasa', width: '40%' },
        { Header: 'Monto', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'monto', width: '15%', alignCell: 'right' },
        { Header: 'Recargo', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'montoRecargo', width: '15%', alignCell: 'right' },
        { Header: 'Total', Cell: (props) => getFormatNumber(props.value, 2), accessor: 'montoTotal', width: '15%', alignCell: 'right' }
    ];

    return (
    <>

        <TableCustom
            showFilterGlobal={true}
            showPagination={true}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={ state.list }
        />

    </>
    );
}

CertificadosApremioItemGrid.propTypes = {
    data: object.isRequired
};
  

export default CertificadosApremioItemGrid;